import { FieldValues, Path, UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import { LabelAndSelect } from "../reuseables/form.comp";
import MultipleShipOptionsSelector from "../reuseables/multipleShipOptionsSelector";

type ShipOptionRestrictionFormProps<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  typeFieldName: Path<T>;
  idsFieldName: Path<T>;
};

export default function ShipOptionRestrictionForm<T extends FieldValues>({
  methods,
  typeFieldName,
  idsFieldName,
}: ShipOptionRestrictionFormProps<T>) {
  const { t, msg } = useTranslation();

  const restrictionType = useWatch({
    name: typeFieldName,
    control: methods.control,
  });

  return (
    <div>
      <LabelAndSelect
        methods={methods}
        label={t(msg.ship.shipOptionRestriction)}
        topLabelCss="block w-full"
        fieldName={typeFieldName}
        options={[
          { label: t(msg.ship.none), value: "none" },
          { label: t(msg.ship.inclusion), value: "inclusion" },
          { label: t(msg.ship.exclusion), value: "exclusion" },
        ]}
      />

      {restrictionType && restrictionType !== "none" ? (
        <div className="space-y-4">
          <MultipleShipOptionsSelector
            methods={methods}
            fieldName={idsFieldName}
            btnId="add-ship-option-restriction-btn"
          />
        </div>
      ) : null}
    </div>
  );
}
